import moment from "moment"

export const MONTH_LABELS = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]

export const SUMMARY_CARDS = [
  { title: "Ventas del día", value: "$0.00", icon: "fa fa-chart-line", color: "#2563eb" },
  { title: "Tickets del día", value: "0", icon: "fa fa-receipt", color: "#16a34a" },
  { title: "Efectivo en caja", value: "$0.00", icon: "fa fa-money-bill", color: "#f59e0b" },
  { title: "Dinero en resguardo", value: "$0.00", icon: "fa fa-lock", color: "#0f766e" },
]

const currencyFormatter = new Intl.NumberFormat("es-MX", {
  style: "currency",
  currency: "MXN",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const formatCurrency = (value) => currencyFormatter.format(Number(value || 0))

export const buildSummaryCards = ({ salesSummary = {}, cashRegister = {}, cashAccount = {} } = {}) => [
  {
    title: "Ventas del día",
    value: formatCurrency(salesSummary.total_sales_amount),
    icon: "fa fa-chart-line",
    color: "#2563eb",
  },
  {
    title: "Tickets del día",
    value: String(Number(salesSummary.tickets_count || 0)),
    icon: "fa fa-receipt",
    color: "#16a34a",
  },
  {
    title: "Efectivo en caja",
    value: formatCurrency(cashRegister.cash),
    icon: "fa fa-money-bill",
    color: "#f59e0b",
  },
  {
    title: "Dinero en resguardo",
    value: formatCurrency(cashAccount.cash),
    icon: "fa fa-lock",
    color: "#0f766e",
  },
]

export const getLastTwelveMonthLabels = () => {
  const today = new Date()
  const labels = []

  for (let offset = 11; offset >= 0; offset -= 1) {
    const date = new Date(today.getFullYear(), today.getMonth() - offset, 1)
    labels.push(`${MONTH_LABELS[date.getMonth()]} ${date.getFullYear()}`)
  }

  return labels
}

export const getLastTwelveMonthRanges = () => {
  const today = moment()

  return Array.from({ length: 12 }, (_, index) => {
    const monthDate = today.clone().subtract(11 - index, "months")

    return {
      key: monthDate.format("YYYY-MM"),
      label: `${MONTH_LABELS[monthDate.month()]} ${monthDate.year()}`,
      startDate: monthDate.clone().startOf("month").format("YYYY-MM-DD"),
      endDate: monthDate.clone().endOf("month").format("YYYY-MM-DD"),
    }
  })
}

export const buildMonthlyDailySalesSeries = (salesSummary = [], monthValue) => {
  const monthDate = moment(monthValue, "YYYY-MM")
  const daysInMonth = monthDate.daysInMonth()
  const labels = []
  const data = []
  const summaryByDay = new Map(salesSummary.map((item) => [Number(item.day), Number(item.total || 0)]))

  for (let day = 1; day <= daysInMonth; day += 1) {
    const currentDate = monthDate.clone().date(day)
    labels.push(currentDate.format("DD"))
    data.push(summaryByDay.get(day) || 0)
  }

  return { labels, data }
}

export const buildCashSeries = (startDate, endDate) => {
  const start = moment(startDate).startOf("day")
  const end = moment(endDate).endOf("day")
  const totalDays = Math.max(end.diff(start, "days") + 1, 1)
  const labels = []
  const data = []

  for (let index = 0; index < totalDays; index += 1) {
    const date = start.clone().add(index, "day")
    labels.push(date.format("DD MMM"))
    data.push(1500 + ((index + 3) * 173) % 900 + index * 35)
  }

  return { labels, data }
}

export const formatMonthLabel = (monthValue) => {
  const monthDate = moment(monthValue, "YYYY-MM")
  return `${MONTH_LABELS[monthDate.month()]} ${monthDate.year()}`
}